module.exports = __webpack_public_path__ + "img/36_78.7c2ba594.png";